import { Link } from 'react-router-dom';
import { Icon } from '@chakra-ui/react';
// import { MdChevronRight } from 'react-icons/md';
import { FaArrowAltCircleRight } from "react-icons/fa";


const priceRanges = [
    { labelLines: ['Under', '₹1,999'], link: '/products/under-1999' },
    { labelLines: ['Under', '₹2,999'], link: '/products/under-2999' },
    { labelLines: ['Under', '₹3,999'], link: '/products/under-3999' },
    { labelLines: ['Under', '₹4,999'], link: '/products/under-4999' },
    { labelLines: ['Under', '₹6,999'], link: '/products/under-6999' },
    { labelLines: ['Shop', 'Exclusive'], link: '/products/shop-exclusive' },
];

function ShopByPrice() {
    return (
        <div>
            {/* <h2 className="text-center text-xl font-semibold py-8">SHOP BY PRICE</h2> */}


            {/* <div className="w-full bg-gradient-to-br from-white via-[#f1f4ff] to-[#e8ecff] py-10 px-4"> */}
            <div className="w-full bg-[#F3F3FD] py-10 px-4">

                <h2 className="text-center text-xl font-semibold pb-8">SHOP BY PRICE</h2>

                <section className="mx-auto max-w-7xl">
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                        {priceRanges.map((range, index) => (
                            <Link
                                key={index}
                                to={range.link}
                                className="group block text-center border border-[#000080] rounded-lg px-4 py-4 pl-6 md:px-6 md:py-6 shadow-sm hover:shadow-lg text-white bg-[#000080] hover:bg-white hover:text-[#000080] transition duration-300"
                            >
                                {/* Labels */}
                                <div className="flex sm:flex-col items-center space-x-1 md:space-y-2 md:mb-4 justify-center">
                                    {range.labelLines.map((line, i) => (
                                        <div
                                            key={i}
                                            className={`leading-tight uppercase ${i === 0 ? "text-[12px] md:text:lg font-semibold" : "text-[12px] md:text-2xl font-semibold"
                                                }`}
                                        >
                                            {line}
                                        </div>
                                    ))}
                                    <div className="md:hidden justify-center flex" >
                                        <div className="flex items-center justify-center p-1 bg-white rounded-full shadow text-[#000080] transition duration-300 group-hover:bg-[#000080] group-hover:text-white">
                                            <Icon as={FaArrowAltCircleRight} w={3} h={3} />
                                        </div>
                                    </div>
                                </div>

                                {/* Right Arrow Icon Below Label */}
                                <div className="md:flex justify-center mt-2 hidden" >
                                    <div className="flex items-center justify-center p-1 bg-white rounded-full shadow text-[#000080] transition duration-300 group-hover:bg-[#000080] group-hover:text-white">
                                        <Icon as={FaArrowAltCircleRight} w={6} h={6} />
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </section>
            </div>

        </div>
    );
}

export default ShopByPrice;
